export const ITEMS = {
  PENNY: {
    id: 'PENNY',
    type: 'resource',
    name: "Penny",
    emoji: "🪙",
    mergeInto: 'NICKEL',
    level: 1
  },
  NICKEL: {
    id: 'NICKEL',
    type: 'resource',
    name: "Nickel", 
    emoji: "💵",
    mergeInto: 'DIME',
    level: 2
  },
  DIME: {
    id: 'DIME',
    type: 'resource',
    name: "Dime",
    emoji: "💴",
    mergeInto: 'QUARTER',
    level: 3
  },
  QUARTER: {
    id: 'QUARTER',
    type: 'resource',
    name: "Quarter",
    emoji: "💶",
    mergeInto: 'DOLLAR',
    level: 4
  },
  DOLLAR: {
    id: 'DOLLAR',
    type: 'resource',
    name: "Dollar",
    emoji: "💷",
    mergeInto: 'WALLET',
    level: 5
  },
  WALLET: {
    id: 'WALLET',
    type: 'resource',
    name: "Wallet",
    emoji: "👛",
    mergeInto: 'SAFE',
    level: 6
  },
  SAFE: {
    id: 'SAFE',
    type: 'resource',
    name: "Safe",
    emoji: "🔒",
    mergeInto: null,
    level: 7
  }
};

export const GENERATORS = {
  BASIC_BANKER: {
    id: 'BASIC_BANKER',
    type: 'generator',
    name: 'Junior Banker',
    emoji: "👨‍💼",
    infinite: true,
    energyCost: 1,
    generates: [
      { itemId: 'PENNY', weight: 1 }
    ],
    charges: 1,
    maxCharges: 1
  },
  FINANCE_ADVISOR: {
    id: 'FINANCE_ADVISOR',
    type: 'generator',
    name: 'Finance Advisor',
    emoji: "👩‍💼",
    infinite: false,
    charges: 5,
    maxCharges: 5,
    generates: [
      { itemId: 'PENNY', weight: 0.8 },
      { itemId: 'NICKEL', weight: 0.2 }
    ]
  },
  INVESTMENT_BROKER: {
    id: 'INVESTMENT_BROKER',
    type: 'generator',
    name: 'Investment Broker',
    emoji: "💼",
    infinite: false,
    charges: 3,
    maxCharges: 3,
    generates: [
      { itemId: 'PENNY', weight: 0.5 },
      { itemId: 'NICKEL', weight: 0.3 },
      { itemId: 'DIME', weight: 0.2 }
    ]
  }
};
